<template>
	<div>
		<slot></slot>
		<div
			key="infiniteScroll"
			ref="infiniteScroll"
			style="height: 1px"
		></div>
	</div>
</template>

<script>
	export default {
		name: 'infinite-scroll',
		props: {
			isFirstPageLoaded: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['trigger'],
		data() {
			return {
				observer: null,
			};
		},
		mounted() {
			this.observer = new IntersectionObserver(entries => {
				this.handleObservedElement(entries);
			});
			this.observer.observe(this.$refs.infiniteScroll);
		},
		beforeUnmount() {
			this.observer.disconnect();
		},
		methods: {
			handleObservedElement(entries) {
				if (this.isFirstPageLoaded && entries[0].intersectionRatio > 0) {
					this.$emit('trigger');
				}
			},
		},
	};
</script>
